import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {UserService} from '../../services/user/user.service';

import {AuthService} from '../../services/auth/auth.service';


@Component({
    selector: 'app-onboarding-user',
    templateUrl: './error-role.component.html',
    styleUrls: ['../../../styles/create-something.scss', 'error-role.component.scss', '../../../styles/standard-elements.scss'],
    standalone: false
})
export class ErrorRoleComponent {

  constructor(private readonly translate: TranslateService,
              readonly userService: UserService,
              public authService: AuthService,
  ) {
  }


  logout() {
    this.authService.logout();
  }
}
